import React from 'react';
import { Link } from 'gatorcomponents';

export default {
  startModal: {
    title: 'Defina seu domínio próprio',
    description: (
      <>
        Seu plano atual está usando um domínio temporário, e para criar um conta de e-mail, você precisa de um domínio próprio.
        <br />
        <br />
        <b>Dica:</b>
        {' '}
        O domínio é o endereço do seu site na internet que pode ser o nome da sua empresa ou marca.
      </>
    ),
    buttonLabel: 'Definir domínio',
  },
  changeDomainPage: {
    breadcrumbs: {
      email: 'E-mails',
      changeDomain: 'Definir domínio',
      buyDomain: 'Comprar domínio',
    },
    loadingLabel: 'Falta pouco! Não feche esta janela...',
    inputPage: {
      title: 'Qual domínio você quer usar no seu plano de e-mail?',
      description: 'Escolha ou crie um domínio que será usado para criar suas contas de e-mail.',
      inputPlaceholder: 'Digite seu domínio completo (ex: meudominio.com.br)',
      inputPlaceholderMobile: 'ex: meudominio.com.br',
      alertDescription: domain => (
        <>
          {'O novo domínio substituirá o atual '}
          <Link text={domain} href={`http://${domain}`} target="_blank" decoration />
          <br />
          <br />
          O e-mail ficará indisponível até que todo o processo seja concluído.
        </>
      ),
      buttonBackLabel: 'Voltar',
      buttonContinueLabel: 'Continuar',
      error: {
        message: 'Verifique e tente novamente.',
        title: 'Informação incorreta',
      },
    },
    notRegistered: {
      title: domain => (
        <>
          {'O domínio "'}
          {domain}
          {'" está disponível para compra'}
        </>
      ),
      description: 'Chegou a hora de comprar seu domínio pra ter sua conta de e-mail profissional. Depois, é só voltar para a área do e-mail Titan e finalizar a configuração.',
      buttonContinueLabel: 'Comprar esse domínio',
      buttonBackLabel: 'Voltar',
    },
    buyingDomain: {
      title: 'Ótima escolha! Você está comprando um domínio',
      description: 'Assim que concluída a compra, retorne para o Painel do Cliente em E-mails e finalize a configuração do DNS.',
      helpLabel: (
        <>
          {'Em caso de dúvidas, '}
          <Link
            text="acesse o material sobre como configurar o DNS."
            target="_blank"
            href="https://suporte.hostgator.com.br/hc/pt-br/articles/30810621770387-Como-configurar-o-dom%C3%ADnio-alterar-DNS"
          />
        </>
      ),
      buttonLabel: 'Voltar para E-mails',
    },
    notAvailableInTitan: {
      title: domain => (
        <>
          {'O domínio "'}
          {domain}
          {'" está indisponível para compra'}
        </>
      ),
      description: 'Este domínio já está em uso por uma conta Titan. Escolha ou crie outro domínio.',
      buttonLabel: 'Tentar outro domínio',
    },
    internalDomain: {
      title: domain => (
        <>
          {'O domínio "'}
          {domain}
          {'" está registrado com a gente'}
        </>
      ),
      description: 'Agora vamos configurar seu domínio e deixar ele pronto para você criar sua conta.',
      checkBoxLabel: 'Confirmo que quero usar esse domínio e que não será possível alterar depois.',
      backButtonLabel: 'Voltar',
      continueButtonLabel: 'Configurar domínio',
    },
    externalDomain: {
      title: domain => (
        <>
          {'O domínio "'}
          {domain}
          {'" está registrado em outra empresa'}
        </>
      ),
      description: 'Por isso, você precisa conectar seu domínio ao nosso e-mail Titan adicionando os registros de DNS (endereço do seu domínio).',
      advise: 'Para fazer isso, você será direcionado para o gerenciamento de e-mail no Painel do Cliente. Siga as orientações que irão aparecer. Se precisar de ajuda, fale com nossa Inteligência Artificial no topo da página.',
      checkBoxLabel: 'Confirmo que quero usar esse domínio e que não será possível alterar depois.',
      backButtonLabel: 'Voltar',
      continueButtonLabel: 'Configurar domínio',
    },
    changedInternalTitanDomain: {
      title: 'Pronto! Seu domínio já está configurado!',
      description: 'Você já pode criar sua conta de e-mail. Mas para enviar e-mail é preciso aguardar até 2 horas para que o endereço funcione direitinho na internet.',
      buttonLabel: 'Criar conta de e-mail',
    },
    changeDomainFail: {
      title: 'Não foi possível concluir a configuração do seu domínio',
      description: 'Aguarde um momento e tente novamente mais tarde.',
      buttonLabel: 'Voltar para E-mails',
    },
  },
};
